import { Empty, EmptyHeader, EmptyDescription } from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";

export default function WidgetEmptyContent() {
  return (
    <Empty className="p-0">
      <EmptyHeader>
        <EmptyDescription>
          <Trans>Det finns tyvärr ingen data att visa.</Trans>
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
